import { parse } from 'content-disposition-attachment';

import {QueryResultItem} from "./models_v2";

//TODO [RGFNLSLA-860] refactor for search
export const updateRelatedData = (list: QueryResultItem[], label: string) => {
  const newExistList = list.map(item => item[label]).filter(item => !!item)

  return [...new Set(newExistList)].join(' ● ')
}

export function getFilenameFromContentDisposition(value: string) {
  const disposition = parse(value)

  if('filename' in disposition){
    return disposition.filename ? disposition.filename : null
  }

  return null;
}
